import * as types from "../actions/ActionTypes";

const defaultState = {
  isRequesting: false,
  categories: [],
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.CATEGORIES_PENDING:
      return Object.assign({}, state, {
        isRequesting: true,
      });
    case types.CATEGORIES_FULFILLED:
      return Object.assign({}, state, {
        isRequesting: false,
        categories: action.payload.map((el) => {
          el.categoryKey = el.name;
          // const translated = getString(`category_${el.name}`);
          // el.name = translated ? translated : el.name;
          return el;
        }),
      });
    case types.CATEGORIES_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        categories: [],
      });

    case "LOGOUT":
      return defaultState;

    default:
      return state;
  }
}
